<header class="header mat-elevation-z4">
  <div class="header__content">
    <div class="header__content__hamburger">
      <mat-icon (click)="sidenav.toggle()">menu</mat-icon>
    </div>
    <div class="header__content__home">
      <a routerLink="/home">
        <span class="header__content__home--i">i</span>
        <span class="header__content__home--audit">Resolve</span>
      </a>
      <!--<ng-template #disabledNavigation>-->
        <!--<span class="header__content__home&#45;&#45;i">i</span>-->
        <!--<span class="header__content__home&#45;&#45;audit">Audit</span>-->
      <!--</ng-template>-->
    </div>

    <iaud-menu class="header__content__menu"></iaud-menu>

    <iaud-profile class="header__content__profile"></iaud-profile>

    <div class="header__content__logo">
      <div class="header__content__logo__image"></div>
    </div>
  </div>
</header>
